import React, { useState, useEffect } from 'react';
import { Container, Section } from 'components/shared';
import { Copy } from 'components/components/atoms';
import Slider from 'react-slick';
import styled from 'styled-components';
import tw from 'twin.macro';
import breakpoints from 'utils/breakpoints';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import useDeviceWidth from 'utils/hooks/useDeviceWidth';
import { AspectRatio } from 'react-aspect-ratio';
import { isValidTitle } from 'utils/validateTitle';

const StyledHeading = styled.h2`
  margin-bottom: 0px;
  font-size: 1.625rem;
  @media ${breakpoints.lg} {
    font-size: 2.25rem;
  }
  @media ${breakpoints.xl} {
    font-size: 2.875rem;
  }
`;

const Grid = styled.div`
  ${tw`px-4`}
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1.875rem;

  @media ${breakpoints.lg} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const StyledImage = styled.img`
  @media ${breakpoints.md} {
    height: 13.75rem;
  }
  @media ${breakpoints.lg} {
    height: 12.313rem;
  }
  @media ${breakpoints.xl} {
    height: 15.438rem;
  }
`;
const CardContainer = styled.div`
  ${({ mobileCardWidth }) =>
    mobileCardWidth && `width: ${mobileCardWidth}px !important;`}
`;

const Card = ({ style, isMobile }) => (
  <figure className='relative'>
    <AspectRatio ratio={isMobile ? '281/187' : '370/247'} className='w-full'>
      <StyledImage
        src={style.imageUrl}
        alt={style.imageAlt}
        className='rounded block w-full object-cover object-center mb-2'
      />
    </AspectRatio>

    <div className='w-full text-center mt-6'>
      <span className='font-trade-gothic-20 text-3xl tracking-tight uppercase text-mattamy-blue'>
        {style.name}
      </span>
    </div>
  </figure>
);

const ExteriorStyles = ({ fields }) => {
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);
  const deviceWidth = useDeviceWidth();
  // const mobileCardWidth = deviceWidth && Math.round(deviceWidth * 0.85);
  const mobileCardWidth = deviceWidth && Math.round(deviceWidth * 0.75);

  const title = getFieldValue(fields, 'title');
  const subtitle = getFieldValue(fields, 'subtitle');
  const styles = getFieldValue(fields, 'styles');

  if (!styles || !styles.length) {
    return null;
  }

  const sliderSettings = {
    className: 'slider h-full overflow-hidden',
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    touchThreshold: 60,
    centerMode: true,
    prevArrow: <></>,
    nextArrow: <></>,
  };
  // console.log({ mobileCardWidth });
  return (
    <Section
      id='exterior-styles'
      className='w-screen flex flex-col items-center justify-start md:pb-10'
      tabIndex='-1'
    >
      <Container className='flex flex-col items-center'>
        {isValidTitle(title) && (
          <StyledHeading className='font-bold leading-tiny text-mattamy-blue font-trade-gothic-20 mb-6 md:mb-10-mattamy'>
            {title}
          </StyledHeading>
        )}
        <Copy className='md:text-lg text-center'>{subtitle}</Copy>
        {!isMobile && (
          <Grid className='mt-60-mattamy w-full'>
            {styles &&
              styles.map((style) => <Card key={style.id} style={style} />)}
          </Grid>
        )}
      </Container>

      {isMobile && (
        <div className='relative w-full mt-30-mattamy'>
          <AspectRatio ratio='281/244' className='w-full'>
            <Slider
              {...sliderSettings}
              /*slides={slides}
              centered={true}
              slidesPerScroll={1}
              minDraggableOffset={1}
              keepDirectionWhenDragging={true}
              itemWidth={isMobile ? mobileCardWidth : 365}*/
            >
              {styles.map((style, i) => (
                <CardContainer
                  key={style.id}
                  mobileCardWidth={mobileCardWidth}
                  className='h-full px-2 md:pb-16 md:pt-4'
                >
                  <Card
                    style={style}
                    data-aos='fade-left'
                    data-aos-delay={i * 150}
                    isMobile={isMobile}
                  />
                </CardContainer>
              ))}
            </Slider>
          </AspectRatio>
        </div>
      )}
    </Section>
  );
};

export default ExteriorStyles;
